module.exports = __webpack_public_path__ + "img/20250519_ATL_V13.fcda0843.png";